  <template>
  <div class="message-user-panel">
    <div class="background" @click="close" />
    <div class="main">
      <div class="control">
        <textarea
          class="textarea"
          v-model="message"
          placeholder="Type message here"
          rows="5"
        ></textarea>
      </div>
      <div style="height: 5px" />
      <div class="msg-btns">
        <span
          class="button"
          v-clipboard:copy="message"
          v-clipboard:success="onCopy"
          ><i class="far fa-clone" />&nbsp;Copy</span
        >
        <span class="button has-text-link" @click="sendMessage('sms')"
          ><i class="fa fa-sms" />&nbsp;SMS</span
        >
        <span class="button has-text-info" @click="sendMessage('push')"
          ><i class="fa fa-paper-plane" />&nbsp;Push</span
        >
        <span class="button has-text-grey" @click="message = null">
          <i class="fa fa-eraser" />&nbsp;Clear</span
        >
      </div>
      <div class="list no-scrollbar" style="height: 200px; overflow: scroll">
        <span
          v-for="m in specialMessageCommands"
          :key="m"
          class="list-item"
          @click="pasteSpecialMessage(m)"
        >
          {{ m }}
          <span
            class="has-text-grey is-pulled-right"
            @click="pushSpecialMessage(m)"
          >
            <i class="fa fa-paper-plane" />
          </span>
        </span>
        <span class="list-item" @click="pasteSpecialMessage(mobileUpdatedMsg)">
          {{ mobileUpdatedMsg }} ...
        </span>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "MessageUserPanel",
  props: {
    ID: String,
  },
  data() {
    return {
      message: null,
      specialMessageCommands: [
        ":ping",
        ":systemStats",
        ":goto:profile",
        ":updateRoles",
        ":clearCache",
        ":restart",
      ],
      mobileUpdatedMsg:
        "Thank you 🙏🏼 Your TUK App mobile number has been updated to",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    onCopy(e) {
      this.$swal({
        title: e.text,
        text: "Copied to clipboard!",
        showConfirmButton: false,
        timer: 1000,
      });
    },
    sendMessage(type) {
      if (!this.message) return;
      var msg = this.message;
      if (this.message[0] === ":") msg = ":" + this.userID() + this.message;
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: this.ID,
          message: msg, //this.message,
          type: type, // send type: sms or push
        })
        .then(() => this.infoToast("Message Sent", "top"))
        .catch((err) => this.apiError(err));
    },
    pasteSpecialMessage(txt) {
      this.message = txt;
      this.$swal.close();
    },
    pushSpecialMessage(txt) {
      this.message = txt;
      this.sendMessage("push");
      this.successToast("Sending notification...", "top");
    },
  },
};
</script>

<style scoped>
.background {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
}
.main {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: whitesmoke;
  padding: 16px 10px;
  width: 100vw;
}
.msg-btns {
  display: flex;
  margin-bottom: 16px;
  gap: 6px;
}
.msg-btns .button {
  flex: 1;
}
</style>